import React from "react";
import QuestionResponsesRating from "./QuestionResponsesRating";
import QuestionResponsesSelect from "./QuestionResponsesSelect";
import QuestionResponsesText from "./QuestionResponsesText";
import QuestionResponsesNPS from "./QuestionResponsesNPS";

const QuestionResponses = ({ question }) => {
    return (
        <>
            {question?.type === "rating" && (
                <QuestionResponsesRating question={question} />
            )}

            {question?.type === "multipleChoiceSingle" && (
                <QuestionResponsesSelect question={question} />
            )}
            {question?.type === "multipleChoiceMulti" && (
                <QuestionResponsesSelect question={question} />
            )}
            {question?.type === "openText" && (
                <QuestionResponsesText question={question} />
            )}
            {question?.type === "nps" && (
                <QuestionResponsesNPS question={question} />
            )}
        </>
    );
};

export default QuestionResponses;
